window._ = require("lodash");
window.$ = window.jQuery = require("jquery");
window.moment = require("moment");
window.numeral = require("numeral");
